<template>
  <div class="">
    <div class="border rounded p-4">
      <h2 class="text-primary lg:text-2xl md:text-2xl text-xl font-semibold">
        Refer your friends and Earn
      </h2>
      <div class="lg:m-4 md:m-4 my-4 text-center">
        <p class="text-primary lg:text-xl md:text-xl text-sm font-semibold">
          Points Earned : <span>{{ karunaAmount }} points</span>
        </p>
        <div class="lg:w-2/3 lg:mx-auto">
          <b-input-group size="md" class="my-4">
            <b-form-input
              type="text"
              disabled
              v-model="karunaCode"
            ></b-form-input>
            <b-input-group-prepend
              ref="modalBody"
              type="button"
              is-text
              class="cursor-pointer"
              @click="copyURL"
            >
              COPY
            </b-input-group-prepend>
          </b-input-group>
        </div>
        <p
          class="text-primary text-center lg:mx-16 lg:text-lg md:text-lg text-sm"
        >
          Earn 10 Karuna Points by getting a loved one who is new to download
          our app.
        </p>
      </div>
    </div>
    <div class="mt-8 border rounded p-4">
      <h2 class="text-black font-semibold">Terms &amp; Conditions</h2>
      <p class="mt-4 text-sm">
        ⦁ Referee and the Referrer cannot have the same credentials.
      </p>
      <p class="mt-1 text-sm">
        ⦁ To be considered a successful Referral, the person you refer should
        download the app and register with us.
      </p>
      <p class="mt-1 text-sm">
        ⦁ The Referee and Referrer will get 10 Karuna Points after each
        successful Registration.
      </p>
      <p class="mt-1 text-sm">
        ⦁ Your Karuna points can be redeemed by you at any point of time.
      </p>
      <p class="mt-1 text-sm">
        ⦁ You can gift your Karuna Points to your loved ones.
      </p>
      <!-- <p class="mt-4 text-sm">
        Referee and the Referrer cannot have the same credentials. To be
        considered a successful Referral, the person you refer should download
        the app and register with us. The Referee and Referrer will get 10
        Karuna Points after each successful Referral. Your Karuna points can be
        redeemed by you at any point of time. You can gift your Karuna Points to
        your loved ones.
      </p> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      karunaCode: "",
      karunaAmount: 0,
    };
  },

  computed: {
    ...mapState("karunaPoint", { karunaPoint: "karunaPoint" }),
    ...mapState("auth", { user: "user" }),
  },

  methods: {
    async copyURL() {
      try {
        await navigator.clipboard.writeText(this.karunaCode);

        // alert("Copied Karuna Code");
        this.$swal.fire({
          text: "Karuna Code copied successfully!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } catch (error) {
        alert("Cannot copy");
      }
    },
    async init() {
      // let getUserPayload = {
      //   userId: this.user._id,
      // };
      // const getUser = await this.$store.dispatch(
      //   "auth/getUserByUserId",
      //   getUserPayload
      // );
      let getKarunaPayload = {
        // userId: this.user._id,
        userRequest: "true",
      };
      const getKaruna = await this.$store.dispatch(
        "karunaPoint/getKarunaPointByUserId",
        getKarunaPayload
      );
      // console.log(getKaruna);
    },
  },
  async mounted() {
    await this.init();
    this.karunaCode = this.karunaPoint.code;
    this.karunaAmount = this.karunaPoint.amount;
  },
};
</script>

<style>
.input-group-text {
  background-color: #4f0a4b;
  font-weight: 600;
  color: white;
}
</style>
